export default __webpack_public_path__ + "static/media/tkqn.c2762220.png";